import { render, staticRenderFns } from "./WKSMenSuoToDoList.vue?vue&type=template&id=725335dd&scoped=true"
import script from "./WKSMenSuoToDoList.vue?vue&type=script&lang=js"
export * from "./WKSMenSuoToDoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "725335dd",
  null
  
)

export default component.exports